import { Text, View } from 'react-native';
import theme from 'theme';
import { calcSizeForDevice } from 'utils/index';

type InfoDescriptionProps = {
  title: string;
  text: string;
  variant?: 'horizontal' | 'vertical' | undefined;
};

const InfoDescription: React.FC<InfoDescriptionProps> = ({ title, text, variant = 'vertical' }) => {
  const isVertical = variant === 'vertical';

  return (
    <View
      style={{ flexDirection: isVertical ? 'column' : 'row', marginBottom: calcSizeForDevice(15) }}>
      <Text
        style={{
          color: 'white',
          fontSize: isVertical ? calcSizeForDevice(18, 24) : calcSizeForDevice(15, 24),
          lineHeight: calcSizeForDevice(18, 32),
          fontFamily: theme.fonts.inter.bold,
          marginBottom: calcSizeForDevice(15, 30),
          marginRight: isVertical ? undefined : calcSizeForDevice(5),
        }}>
        {title}
      </Text>
      <Text
        style={{
          color: 'white',
          flexShrink: 1,
          fontSize: calcSizeForDevice(14, 24),
          lineHeight: calcSizeForDevice(18, 32),
          fontFamily: theme.fonts.inter.regular,
          marginBottom: isVertical ? calcSizeForDevice(24) : undefined,
        }}>
        {text}
      </Text>
    </View>
  );
};

export default InfoDescription;
